<template>
  <div
    class="w-full"
    :class="small ? 'lg:w-3/12' : medium ? 'lg:w-4/12' : 'lg:w-8/12'"
  >
    <slot />
  </div>
</template>

<script>

export default {
  name: 'LeftColumn',
  props: {
    small: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    }
  }
}
</script>
